<script lang="ts">
export default {
  name: 'CreateTemplateModal',
};
</script>

<script setup lang="ts">
import { ref, watch } from 'vue';
import AppModal from '@/components/v2/AppModal.vue';
import DashboardTemplateService from '@/services/v2/DashboardTemplateService';

const props = defineProps<{
  show: boolean;
}>();

const emit = defineEmits<{
  close: [];
  created: [];
}>();

const title = ref('');
const description = ref('');
const saving = ref(false);

watch(
  () => props.show,
  (visible) => {
    if (visible) {
      title.value = '';
      description.value = '';
    }
  },
);

async function save() {
  if (!title.value.trim() || saving.value) return;
  saving.value = true;
  try {
    await DashboardTemplateService.create({
      title: title.value.trim(),
      description: description.value.trim() || undefined,
    });
    emit('created');
  } catch {
    console.error('Failed to create template from user dashbaord');
  } finally {
    saving.value = false;
  }
}
</script>

<template>
  <AppModal
    :show="show"
    title="Create Template"
    cancel-button-label="Cancel"
    action-button-label="Save Template"
    :handle-cancel="() => emit('close')"
    :handle-action="save"
    :action-disabled="!title.trim()"
    :loading="saving"
    size="md">
    <template #content>
      <div class="flex flex-col gap-4">
        <label class="form-control w-full">
          <div class="label">
            <span class="label-text font-medium">Title</span>
          </div>
          <input
            v-model="title"
            type="text"
            placeholder="Template name"
            class="input-bordered input input-sm w-full"
            maxlength="255" />
        </label>
        <label class="form-control w-full">
          <div class="label">
            <span class="label-text font-medium">Description</span>
          </div>
          <textarea
            v-model="description"
            placeholder="Optional description"
            class="textarea-bordered textarea w-full textarea-sm"
            rows="3"></textarea>
        </label>
        <p class="text-xs text-base-content/50">Your current dashboard layout will be saved as a template that other users can apply.</p>
      </div>
    </template>
  </AppModal>
</template>
